import check_mask from "./MaskValidation";

export const MASK_BLUR_STRATEGY = {
  DEFAULT: "default",
  CATALOGUE: "catalogue",
};

export function applyMaskOnBlur(rawValue, pictureMask, options = {}) {
  const inputValue = rawValue == null ? "" : String(rawValue);
  const normalizedMask = pictureMask ? String(pictureMask).replace(/"/g, "") : "";

  // Do not auto-format empty/whitespace input on blur.
  if (inputValue.trim() === "") {
    return { nextValue: inputValue, isValid: true, applied: false };
  }

  if (!normalizedMask) {
    return { nextValue: inputValue, isValid: true, applied: false };
  }

  const { isValid, formattedValue } = check_mask(inputValue, normalizedMask);
  const nextValue = formattedValue == null ? inputValue : String(formattedValue);
  const strategy = options.strategy || MASK_BLUR_STRATEGY.DEFAULT;

  if (strategy === MASK_BLUR_STRATEGY.CATALOGUE) {
    const safeValue = isValid ? nextValue : inputValue;
    return {
      nextValue: safeValue,
      isValid,
      applied: safeValue !== inputValue,
    };
  }

  return {
    nextValue,
    isValid,
    applied: nextValue !== inputValue,
  };
}
